<template>
  <div class="employeeRoster page-customer">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput" v-if="activeName == '项目列表'">
            <div class="flname">项目名称</div>
            <el-input
              size="small"
              v-model="infoQuery.objname"
              clearable
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
          <div class="screenInput" v-if="activeName != '项目列表'">
            <div class="flname">项目名称</div>
            <el-input
              size="small"
              v-model="rosterQuery.custname"
              clearable
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
          <div class="screenInput" v-if="activeName == '项目列表'">
            <div class="flname">导入状态</div>
            <el-select
              v-model="infoQuery.stremptype"
              filterable
              @change="searchHandle"
              clearable
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="已导入" value="1"></el-option>
              <el-option label="未导入" value="2"></el-option>
            </el-select>
          </div>
          <div class="screenInput" v-if="activeName != '项目列表'">
            <div class="flname">姓名</div>
            <el-input
              size="small"
              v-model="rosterQuery.username"
              clearable
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
        <button v-if="
            checkPermission(['customerList_export'], permissionLists) &&
            activeName == '项目列表'
          "
          class="search"
          @click="templateDownload"
          style="margin-left: 10px"
        >
          导入模板下载
        </button>
        <button
          v-if="
            checkPermission(['customerList_export'], permissionLists) &&
            activeName == '项目列表'
          "
          class="exportButton"
          @click="exportAllInfo"
        >
          全员导出
        </button>
        <el-button
          v-if="activeName != '项目列表' && tableData != []"
          type="primary"
          size="small"
          @click="exportHandle"
          :loading="btnLoading"
          style="margin-right: 10px"
          >导出</el-button
        >
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="cus_down_box" v-if="activeName != '项目列表'">
          <el-form
            :inline="true"
            :model="rosterQuery"
            class="cus_down_form"
            label-width="100px"
          >
            <el-form-item label="电话:">
              <el-input
                size="small"
                v-model="rosterQuery.strtel"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="岗位类别:">
              <el-cascader
                v-model="posCategoryList"
                :props="propPosition"
                clearable
                :options="positionList"
                @change="poSectionChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="业务类型:">
              <el-select v-model="rosterQuery.actualtype" filterable clearable>
                <el-option
                  v-for="(item, index) in businessList"
                  :key="index"
                  :label="item.StrBusitypeName"
                  :value="item.Busitypeid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务部门:">
              <el-cascader
                v-model="dedpartNameList"
                :props="props"
                clearable
                filterable
                :options="departList"
                @change="handleSectionChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="客服:">
              <el-select
                v-model="rosterQuery.strservuserid"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in customerList"
                  :key="index + 'a'"
                  :label="item.Username"
                  :value="item.Userid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务立项部门:">
              <el-cascader
                v-model="busDedpartList"
                :props="props"
                clearable
                filterable
                :options="departList"
                @change="handleBusSectionChange"
              ></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="业务员:">
              <el-input size="small" v-model="rosterQuery.strAchieveowner" clearable></el-input>
            </el-form-item>
            <el-form-item label="招聘部门:">
              <el-input size="small" v-model="rosterQuery.strRecchannel" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="招聘渠道:">
              <el-select
                v-model="rosterQuery.strRecdep"
                clearable
                placeholder=""
                size="small"
              >
                <el-option value="社招">社招</el-option>
                <el-option value="公司渠道">公司渠道</el-option>
                <el-option value="外部渠道">外部渠道</el-option>
                <el-option value="企业转移">企业转移</el-option>
                <el-option value="内荐">内荐</el-option>
                <el-option value="独立招聘">独立招聘</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="招聘顾问:">
              <el-input
                size="small"
                v-model="rosterQuery.strRecsult"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="项目城市:">
              <el-input
                size="small"
                v-model="rosterQuery.strcity"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="cus_down_box" v-if="activeName == '项目列表'">
          <el-form
            :inline="true"
            :model="infoQuery"
            class="cus_down_form"
            label-width="100px"
          >
            <el-form-item label="服务中心:">
              <el-select
                v-model="infoQuery.strsrvcent"
                filterable
                @change="serviceChange"
                clearable
              >
                <el-option
                  v-for="(item, index) in serviceList"
                  :key="index"
                  :label="item.StrSrvCent"
                  :value="item.StrSrvCent"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务立项部门:">
              <el-select
                v-model="infoQuery.strobjinstname"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in apartmentList"
                  :key="index"
                  :label="item.StrObjInstName"
                  :value="item.StrObjInstName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责客服:">
              <el-input
                size="small"
                v-model="infoQuery.strusername"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
          <button
            class="clear"
            style="margin-right: 10px"
            @click="resetHandle()"
          >
            清空
          </button>
          <button class="search" @click="searchHandle()">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item>存档花名册</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="p_roster_table"
      >
        <!-- 招聘角色不能看雇员花名册 -->
        <el-tab-pane
          label="项目列表"
          name="项目列表"
          v-if="checkPermission(['customerList_tab_list'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="在职"
          name="在职"
          v-if="checkPermission(['customerList_tab_onjob'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职"
          name="离职"
          v-if="checkPermission(['customerList_tab_depart'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职转正"
          name="离职转正"
          v-if="
            checkPermission(['customerList_tab_transform'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="自离"
          name="自离"
          v-if="
            checkPermission(['customerList_tab_selfdepart'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="黑名单雇员"
          name="黑名单雇员"
          v-if="
            checkPermission(['customerList_tab_blacklist'], permissionLists)
          "
        ></el-tab-pane>
        <!-- <el-tab-pane label="历史花名册" name="历史花名册" v-if="roleType != 'recdirec' && roleType != 'recruit'"></el-tab-pane> -->
        <el-tab-pane
          label="导入导出记录"
          name="导入导出记录"
          v-if="
            checkPermission(['customerList_import'], permissionLists) ||
            checkPermission(['customerList_export'], permissionLists)
          "
        ></el-tab-pane>
        <!-- <el-tab-pane label="导入字段管理" name="导入字段管理" v-if="roleType.indexOf('admin')>-1"></el-tab-pane> -->
      </el-tabs>
      <div class="employeeRosterTable">
        <ItemList
          v-if="
            checkPermission(['customerList_tab_list'], permissionLists) &&
            activeName == '项目列表'
          "
          ref="itemList"
          @func="getItemDataSon"
          :toChildrenData="infoQuery"
          :toPermissionLists="permissionLists"
          :toFieldList="allFieldList"
        />
        <RosterList
          v-if="
            activeName != '项目列表' &&
            (checkPermission(['customerList_tab_onjob'], permissionLists) ||
              checkPermission(['customerList_tab_depart'], permissionLists) ||
              checkPermission(
                ['customerList_tab_transform'],
                permissionLists
              ) ||
              checkPermission(['customerList_tab_selfdepart'], permissionLists))
          "
          ref="rosterList"
          @func="getRosterDataSon"
          :toChildrenData="rosterQuery"
        />
      </div>
    </div>

    <div class="dialog">
      <!-- 导入模板下载 -->
      <el-dialog :visible.sync="dialogVisible3" width="480px">
        <div class="diaTitle">导入模板下载</div>
        <div style="padding: 10px 0px 20px">
          <p>注：所有日期格式都是YYYY-MM-DD格式</p>
          <a :href="this.modepath">点击下载</a>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button
            class="search"
            @click="dialogVisible3 = false"
            style="margin-left: 10px; font-weight: 600"
          >
            <a :href="this.modepath" style="font-weight: 600; color: #19bd92"
              >点击下载</a
            >
          </button>
        </span>
      </el-dialog>
      <!-- 导出 -->
      <el-dialog :visible.sync="dialogVisible4" width="800px">
        <div class="diaTitle">全员导出</div>
        <div>
          <div style="margin-bottom: 12px; margin-top: 15px; font-size: 16px">
            选择导出字段
          </div>
          <el-tabs type="border-card">
            <el-tab-pane label="固定字段">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="checkedFields"
                @change="handleCheckedCitiesChange"
              >
                <div class="fieldBox">
                  <el-checkbox
                    v-for="(field, index) in fixedfields"
                    :label="field"
                    :key="index"
                    >{{ field }}</el-checkbox
                  >
                </div>
              </el-checkbox-group>
            </el-tab-pane>
          </el-tabs>
          <div style="margin-top: 20px">
            <div class="delTitle">选择导出人员在/离职状态</div>
            <div>
              <div class="dataSele">
                <el-select
                  v-model="workState"
                  slot="prepend"
                  placeholder="请选择"
                  filterable
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option value="在职"></el-option>
                  <el-option value="离职"></el-option>
                  <el-option value="离职转正"></el-option>
                  <el-option value="自离"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible4 = false">取消</button>
          <button
            class="search"
            @click="confirmExport()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { VueTreeList, Tree } from "vue-tree-xz";
import checkPermission from "@/utils/permission"; // 权限判断函数
import ItemList from "./components/itemList.vue";
import RosterList from "./components/rosterList.vue";
import xz from "../../common";
export default {
  components: {
    VueTreeList,
    ItemList,
    RosterList,
  },
  data() {
    return {
      activeName: "",
      //是否下载过导入模板
      isDownload: false,
      rowinfo: null,
      //在/离职状态
      workState: "",
      //导出弹窗
      expSelectDialog: false,
      //角色类型
      roleType: "",
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      //所有导入字段
      currFileData: [],
      currFileData2: [],
      checkAll: false,
      checkAll2: false,
      checkedFields: [],
      // checkedFields2: [],
      fixedfields: [],
      otherfields: [],
      tableclumn: [],
      tableclumn1: [],
      tableclumn2: [],
      isIndeterminate: true,
      //表头错误提示
      isError: false,
      errorTxt: "",
      listLoading: false,
      //导入模板链接
      modepath: "",
      //导入到的项目名称
      exportName: "",
      //数据数量
      totalcount: null,
      showResult: false,
      //下拉筛选
      showDropScreen: -1,
      //导入模板下载
      dialogVisible3: false,
      //导出
      dialogVisible4: false,
      tableData: [],
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      //项目列表参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        objname: "", //项目名称
        ctluserid: "",
        strsrvcent: "", //服务中心
        strobjinstname: "", //立项部门
        strusername: "", //客服名称
        strbusistat: "", //服务状态
        stremptype: "0",
        roletype: "",
      },
      // 花名册列表参数
      rosterQuery: {
        strorgancode: "",
        roletype: "",
        currpage: 1,
        perpage: 10,
        custname: "", // 项目名称
        username: "", // 姓名
        depname: "", // 归属业务部(业务立项部门)
        servicename: "", // 客服
        strWork: "", // 在离职状态
        strtel: "", //电话
        strjobtype: "", //岗位类别
        actualtype: "", //业务类型
        strDep1: "", //部门一级
        strDep2: "", //部门二级
        strDep3: "", //部门三级
        strservuserid: "", //客服
        strAchievedep: "", //归属业务部门
        strAchieveowner: "", //业务员
        strRecchannel: "", //招聘部门
        strRecsult: "", //招聘顾问
        strRecdep: "", //招聘渠道
        strcity: "", //城市
      },
      allFieldList: [],
      //导出按钮加载状态
      btnLoading: false,
      // 导出新花名册参数
      exportNewQuery: {
        strorgancode: "",
        roletype: "",
        custname: "", //项目名称
        username: "", //姓名
        depname: "", //归属业务部(业务立项部门)
        servicename: "", //客服
        strWork: "", //在离职状态
        strtel: "", //电话
        strjobtype: "", //岗位类别
        actualtype: "", //业务类型
        strDep1: "", //部门一级
        strDep2: "", //部门二级
        strDep3: "", //部门三级
        strservuserid: "", //客服
        strAchievedep: "", //归属业务部门
        strAchieveowner: "", //业务员
        strRecchannel: "", //招聘部门
        strRecsult: "", //招聘顾问
        strRecdep: "", //招聘渠道
        strcity: "", //城市
        outtype: "1",
        tableid: "XZ_emp_UserBase_out",
      },
      // 参数列表参数
      paramQuery: {
        currpage: 1,
        perpage: 100000,
        keyword: "",
        strIsDisable: "", // 传1 禁用的看不到了  不传就全显示
        // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级
        // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
        strtableid: "",
      },
      // 客服
      customerList: [],
      // 选中的服务部门
      dedpartNameList: [],
      // 选中的归属业务部门
      busDedpartList: [],
      // 岗位类别
      posCategoryList: [],
      positionList: [],
      // 业务类型
      businessList: [],
      // 部门参数
      departQuery: {
        strorgancode: "",
        roletype: "",
      },
      // 部门
      departList: [],
      // 员工参数
      departMemberQuery: {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "",
        strstation: "",
        strorgancode: "",
      },
      // 按钮权限参数
      butQuery: {
        path: "/customerList",
        powerEnName: "projectManage",
      },
      permissionLists: [], //按钮权限列表
      // 自定义 级联选择props
      props: {
        label: "strorganname",
        value: "strorgancode",
        children: "children",
        checkStrictly: true,
      },
      propPosition: {
        label: "strParametername",
        value: "strParametername",
        children: "children",
      },
    };
  },
  created() {
    // let currName = this.$route.query.currname
    this.infoQuery.roletype = localStorage.loginRoletype;
    this.getButtonPower();
    this.rosterQuery.roletype = localStorage.loginRoletype;
    this.rosterQuery.strorgancode = localStorage.gancode;
    this.departQuery.roletype = localStorage.loginRoletype;
    this.departQuery.strorgancode = localStorage.gancode;
    if (window.localStorage.getItem("loginRoletype")) {
      this.roleType = window.localStorage.getItem("loginRoletype");
    }
    if (window.localStorage.getItem("isDownload")) {
      this.calDaysBetween(window.localStorage.getItem("isDownload"));
    }
    // console.log('oooo', this.activeName)
    this.calHeight();
    this.getServiceList();
    this.getApartmentList("", "");
    this.getImportFiledList();
    // 业务类型
    this.getParamList("JB_base_Busitype");
    // 岗位类别
    this.getTreestr();
    // 获取部门列表
    this.getDepartList();
    this.getMemberList("customer");
  },
  computed: {
    searchResult() {
      if (this.$store.state.ADDCOMPANY.customerMatch.length > 0) {
        this.showResult = true;
      }
      return this.$store.state.ADDCOMPANY.customerMatch;
    },
  },
  methods: {
    checkPermission,
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height', this.tableHeight)
    },
    // 调用子组件方法，动态传参
    invokeChildMethod(val) {
      this.$refs.itemList.printButton(val);
    },
    // 调用子组件方法，动态传导出字段
    invokeFileMethod(val) {
      // console.log('333', val)
      this.$refs.itemList.printFile(val);
    },
    // 调用子组件方法(项目列表)
    invokeChildProMethod() {
      // console.log('22', val)
      let this_ = this;
      this.$nextTick(() => {
        this_.$refs.itemList.getCustomerList(this_.infoQuery);
      });
    },
    // 调用子组件方法(花名册列表)
    invokeChildRosterMethod() {
      // console.log('111', val)
      let this_ = this;
      this.$nextTick(() => {
        this_.$refs.rosterList.getList(this_.rosterQuery);
      });
    },
    //获取子组件传到父组件的tableList(项目列表)
    async getItemDataSon(data) {
      this.tableData = [];
      this.tableData = data;
      // console.log('ff',data)
    },
    //获取子组件传到父组件的tableList(新花名册)
    async getRosterDataSon(data) {
      this.tableData = [];
      this.tableData = data;
      // console.log('ff',data)
    },
    // 获取按钮权限
    getButtonPower() {
      let that = this;
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if (that.isNull(that.$route.query.currname)) {
              //不是从别的tab跳转过来
              if (
                that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                )
              ) {
                that.activeName = "项目列表";
                that.rosterQuery.strWork = "";
                that.$nextTick(() => {
                  that.invokeChildProMethod();
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                )
              ) {
                that.activeName = "在职";
                that.$router.push({
                  path: "/customerList",
                  query: {
                    currname: "在职",
                  },
                });
                that.rosterQuery.strWork = this.activeName;
                that.$nextTick(() => {
                  that.invokeChildRosterMethod();
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                ) &&
                that.checkPermission(
                  ["customerList_tab_depart"],
                  that.permissionLists
                )
              ) {
                that.activeName = "离职";
                that.$router.push({
                  path: "/customerList",
                  query: {
                    currname: "离职",
                  },
                });
                that.rosterQuery.strWork = this.activeName;
                that.$nextTick(() => {
                  that.invokeChildRosterMethod();
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_depart"],
                  that.permissionLists
                ) &&
                that.checkPermission(
                  ["customerList_tab_transform"],
                  that.permissionLists
                )
              ) {
                that.activeName = "离职转正";
                that.$router.push({
                  path: "/customerList",
                  query: {
                    currname: "离职转正",
                  },
                });
                that.rosterQuery.strWork = this.activeName;
                that.$nextTick(() => {
                  that.invokeChildRosterMethod();
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_depart"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_transform"],
                  that.permissionLists
                ) &&
                that.checkPermission(
                  ["customerList_tab_selfdepart"],
                  that.permissionLists
                )
              ) {
                that.activeName = "自离";
                that.$router.push({
                  path: "/customerList",
                  query: {
                    currname: "自离",
                  },
                });
                that.rosterQuery.strWork = this.activeName;
                that.$nextTick(() => {
                  that.invokeChildRosterMethod();
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_depart"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_transform"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_selfdepart"],
                  that.permissionLists
                ) &&
                that.checkPermission(
                  ["customerList_tab_blacklist"],
                  that.permissionLists
                )
              ) {
                that.activeName = "黑名单雇员";
                that.$router.push({
                  path: "/blacklist",
                  query: {
                    currname: "黑名单雇员",
                  },
                });
              } else if (
                !that.checkPermission(
                  ["customerList_tab_list"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_onjob"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_depart"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_transform"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_selfdepart"],
                  that.permissionLists
                ) &&
                !that.checkPermission(
                  ["customerList_tab_blacklist"],
                  that.permissionLists
                ) &&
                (that.checkPermission(
                  ["customerList_import"],
                  that.permissionLists
                ) ||
                  that.checkPermission(
                    ["customerList_export"],
                    that.permissionLists
                  ))
              ) {
                that.activeName = "导入导出记录";
                that.$router.push({
                  path: "/operationRecord",
                  query: {
                    currname: "导入导出记录",
                  },
                });
              }
            } else {
              that.activeName = that.$route.query.currname;
              if (that.activeName == "项目列表") {
                that.rosterQuery.strWork = "";
                that.invokeChildProMethod();
                // that.invokeFileMethod(that.allFieldList)
              } else {
                if (
                  that.activeName == "在职" ||
                  that.activeName == "离职" ||
                  that.activeName == "离职转正" ||
                  that.activeName == "自离"
                ) {
                  that.rosterQuery.strWork = this.activeName;
                  that.$nextTick(() => {
                    that.invokeChildRosterMethod();
                  });
                }
              }
            }
          } else {
            this.permissionLists = [];
            this.activeName = "";
          }
        } else {
          this.permissionLists = [];
          this.activeName = "";
        }
      });
    },
    // 岗位类别
    poSectionChange(val) {
      // console.log('vv',val)
      this.rosterQuery.strjobtype = val[Number(val.length) - 1];
    },
    // 归属业务部门
    handleBusSectionChange(val) {
      this.rosterQuery.strAchievedep = val[Number(val.length) - 1];
    },
    // 服务部门选择
    handleSectionChange(value) {
      // console.log(value)
      this.rosterQuery.strservuserid = "";
      if (value.length >= 3) {
        this.rosterQuery.strDep1 = value[0];
        this.rosterQuery.strDep2 = value[1];
        this.rosterQuery.strDep3 = value[2];
      }
      if (value.length == 2) {
        this.rosterQuery.strDep1 = value[0];
        this.rosterQuery.strDep2 = value[1];
        this.rosterQuery.strDep3 = "";
      }
      if (value.length == 1) {
        this.rosterQuery.strDep1 = value[0];
        this.rosterQuery.strDep2 = "";
        this.rosterQuery.strDep3 = "";
      }
      // this.departQuery.strorgancode = value[Number(value.length)-1]
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.getMemberList('customer',this.departQuery.strorgancode,this.departQuery.roletype)
    },
    // 岗位类别
    getTreestr() {
      let data = {
        currpage: 1,
        perpage: 100,
        strIsDisable: "", // 传1 禁用的看不到了  不传就全显示
        keyword: "",
      };
      xz.getTreestr("JB_base_Jobcategory", data).then((res) => {
        if (res) {
          this.positionList = res.msg.parent;
        } else {
          this.positionList = [];
        }
      });
    },
    // 获取参数列表
    getParamList(type) {
      this.paramQuery.strtableid = type;
      xz.getParameterList(this.paramQuery).then((res) => {
        // console.log('参数', res)
        if (res.status == "ok") {
          if (type == "JB_base_Busitype") {
            // 业务类型
            this.businessList = res.msg;
          }
        } else {
          if (type == "JB_base_Busitype") {
            // 业务类型
            this.businessList = [];
          }
        }
      });
    },
    // 获取员工列表
    getMemberList(type) {
      xz.getauthUserInfoByorgancode(this.departMemberQuery).then((res) => {
        // console.log('员工', res)
        if (res.status == "ok") {
          if (type == "customer") {
            this.customerList = res.msg;
          }
        } else {
          if (type == "customer") {
            // 客服列表
            this.customerList = [];
          }
        }
      });
    },
    // 导出新花名册
    exportHandle() {
      this.btnLoading = true;
      this.exportNewQuery.custname = this.rosterQuery.custname;
      this.exportNewQuery.username = this.rosterQuery.username;
      this.exportNewQuery.depname = this.rosterQuery.depname;
      this.exportNewQuery.servicename = this.rosterQuery.servicename;
      this.exportNewQuery.strWork = this.rosterQuery.strWork;
      this.exportNewQuery.strtel = this.rosterQuery.strtel;
      this.exportNewQuery.strjobtype = this.rosterQuery.strjobtype;
      this.exportNewQuery.actualtype = this.rosterQuery.actualtype;
      this.exportNewQuery.strDep1 = this.rosterQuery.strDep1;
      this.exportNewQuery.strDep2 = this.rosterQuery.strDep2;
      this.exportNewQuery.strDep3 = this.rosterQuery.strDep3;
      this.exportNewQuery.strservuserid = this.rosterQuery.strservuserid;
      this.exportNewQuery.strAchievedep = this.rosterQuery.strAchievedep;
      this.exportNewQuery.strAchieveowner = this.rosterQuery.strAchieveowner;
      this.exportNewQuery.strRecchannel = this.rosterQuery.strRecchannel;
      this.exportNewQuery.strRecsult = this.rosterQuery.strRecsult;
      this.exportNewQuery.strRecdep = this.rosterQuery.strRecdep;
      this.exportNewQuery.strcity = this.rosterQuery.strcity;
      this.exportNewQuery.roletype = this.rosterQuery.roletype;
      this.exportNewQuery.strorgancode = this.rosterQuery.strorgancode;
      xz.getOutEmpBaseUser(this.exportNewQuery).then((res) => {
        // console.log('导出新花名册', res)
        if (res.status == "ok") {
          // console.log('导出', data)
          this.$router.push({
            path: "/operationRecord",
            query: {
              showPage: 1,
              isActive: 1,
              custname: res.msg,
              //qStstus=1时查看最后一条导出记录
              qStstus: 1,
            },
          });
        } else {
          this.$message({
            message: "导出失败，请稍后再试",
            type: "error",
          });
        }
        this.btnLoading = false;
      });
    },
    //切换tab
    handleClick(tab, event) {
      // console.log('tab',tab, event);
      // let pathList;
      // pathList = ['/customerList?currname=项目列表','/customerList?currname=在职','/customerList?currname=离职','/customerList?currname=离职转正','/customerList?currname=自离','/blacklist','/operationRecord']
      if (tab.name == "项目列表") {
        //项目列表
        this.infoQuery.currpage = 1;
        this.$nextTick(() => {
          this.$refs.itemList.getCustomerList(this.infoQuery);
        });
      } else if (
        tab.name == "在职" ||
        tab.name == "离职" ||
        tab.name == "离职转正" ||
        tab.name == "自离"
      ) {
        //花名册列表
        this.rosterQuery.currpage = 1;
        this.rosterQuery.strWork = tab.label;
        this.$nextTick(() => {
          this.$refs.rosterList.getList(this.rosterQuery);
        });
      } else {
        if (tab.name == "黑名单雇员") {
          this.$router.push({
            path: "/blacklist",
            query: {
              currname: "黑名单雇员",
            },
          });
        }
        if (tab.name == "导入导出记录") {
          this.$router.push({
            path: "/operationRecord",
            query: {
              currname: "导入导出记录",
            },
          });
        }
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    //下载模板
    downLoadHandle() {
      xz.getImportMode().then((res) => {
        // console.log('下载模板', res)
        if (res) {
          this.isDownload = true;
          window.localStorage.setItem("isDownload", new Date());
          var d = res.msg.data.StrOutPath;
          d = d.replace('"', "").replace('"', "");
          var path = this.tablePath + d;
          const aTag = document.createElement("a");
          aTag.href = path;
          aTag.click();
        }
      });
    },
    calDaysBetween(date) {
      let startDate = Date.parse(date);
      let endDate = Date.parse(new Date());
      let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      days > 7 ? (this.isDownload = false) : (this.isDownload = true);
    },
    serviceChange() {
      this.getApartmentList(this.infoQuery.strsrvcent, this.infoQuery.objname);
    },
    // 获取部门列表
    getDepartList() {
      xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
        strIsDisable: "",
      }).then((res) => {
        // console.log('部门', res)
        if (res.status == "ok") {
          if (res.msg && res.msg.parent) {
            this.departList = res.msg.parent[0].children;
          }
        } else {
          this.departList = [];
        }
      });
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName });
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    //清空
    resetHandle() {
      this.infoQuery = {
        pagecount: 10,
        currpage: 1,
        objname: "", //项目名称
        ctluserid: "",
        strsrvcent: "", //服务中心
        strobjinstname: "", //立项部门
        strusername: "", //客服名称
        strbusistat: "", //服务状态
        stremptype: "0",
        roletype: localStorage.loginRoletype,
      };
      this.rosterQuery = {
        strorgancode: localStorage.gancode,
        roletype: localStorage.loginRoletype,
        currpage: 1,
        perpage: 10,
        custname: "", // 项目名称
        username: "", // 姓名
        depname: "", // 归属业务部(业务立项部门)
        servicename: "", // 客服
        strWork: this.rosterQuery.strWork, // 在离职状态
        strtel: "", //电话
        strjobtype: "", //岗位类别
        actualtype: "", //业务类型
        strDep1: "", //部门一级
        strDep2: "", //部门二级
        strDep3: "", //部门三级
        strservuserid: "", //客服
        strAchievedep: "", //归属业务部门
        strAchieveowner: "", //业务员
        strRecchannel: "", //招聘部门
        strRecsult: "", //招聘顾问
        strRecdep: "", //招聘渠道
        strcity: "", //城市
      };
      this.posCategoryList = [];
      this.dedpartNameList = [];
      this.busDedpartList = [];
    },
    //搜索
    searchHandle() {
      this.infoQuery.currpage = 1;
      // this.rosterQuery.currpage = 1
      // this.rosterQuery.custname = this.infoQuery.objname
      // this.rosterQuery.depname = this.infoQuery.strobjinstname
      // this.rosterQuery.servicename = this.infoQuery.strusername
      if (this.activeName == "项目列表") {
        this.$nextTick(() => {
          this.$refs.itemList.getCustomerList(this.infoQuery);
        });
      } else {
        // console.log('kk',this.$refs.rosterList)
        this.$nextTick(() => {
          this.$refs.rosterList.getList(this.rosterQuery);
        });
      }
    },
    exportAllInfo() {
      this.getlastExportList();
    },
    //全员导出字段全选
    handleCheckAllChange(val) {
      // this.tableclumn = this.currFileData;
      this.checkedFields = val ? this.fixedfields : [];
      this.tableclumn1 = val ? this.currFileData : [];
      if (val == false) {
        this.tableclumn1 = [
          { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
        ];
      }
      this.isIndeterminate = false;
      this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
      // console.log('选择的字段', this.tableclumn)
    },
    //全员导出字段选择
    handleCheckedCitiesChange(value) {
      // console.log('val', value)
      this.tableclumn1 = [
        { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
      ];
      for (let index = 0; index < this.currFileData.length; index++) {
        // const elementFileDatas = this.currFileData[index];
        if (value != "" && value != null) {
          for (let i = 0; i < value.length; i++) {
            // const elementVal = value[index];
            if (value[i] == this.currFileData[index].name) {
              this.tableclumn1.push(this.currFileData[index]);
            }
          }
        } else {
          this.tableclumn1 = [
            { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
          ];
        }
      }
      //去重
      this.tableclumn1 = this.unique(this.tableclumn1);
      this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
      // console.log('val', this.tableclumn)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.fixedfields.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fixedfields.length;
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter(
        (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
      );
    },
    //获取所有字段信息
    getImportFiledList() {
      const data = {
        pagecount: 100000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "all", //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
      };
      this.fixedfields = [];
      xz.getImportFiledInfo(data).then((res) => {
        // console.log('固定导出字段',res)
        if (res && res.data.length > 0) {
          for (let index = 0; index < res.data.length; index++) {
            const elementRes = res.data[index];
            this.fixedfields.push({
              name: elementRes.StrColumName,
              colname: elementRes.StrColumId,
              intOrderId: elementRes.IntOrderId,
            });
            this.allFieldList.push({
              name: elementRes.StrColumName,
              colname: elementRes.StrColumId,
              intOrderId: elementRes.IntOrderId,
            });
          }
          //去重
          this.currFileData = this.unique(this.fixedfields);
          // console.log('ss',this.allFieldList)
          this.fixedfields = [];
          for (let index = 0; index < this.currFileData.length; index++) {
            const elementData = this.currFileData[index];
            this.fixedfields.push(elementData.name);
          }
          // console.log('s1', this.fixedfields, this.allFieldList)
        }
      });
    },
    //获取最新一条导出记录
    async getlastExportList() {
      xz.getLastExpData("全员导出").then((res) => {
        // console.log('全员导出', res)
        if (res && res != "没有记录！") {
          if (
            new Date().getTime() < new Date(res.DtImpDate).getTime() + 360000 &&
            this.isNull(res.StrOutPath)
          ) {
            this.$message({
              showClose: true,
              message: "全员导出一次后需六分钟后才能再导出，请稍后再导",
              type: "warning",
            });
          } else {
            this.dialogVisible4 = true;
          }
        } else {
          this.dialogVisible4 = true;
        }
      });
    },
    confirmExport() {
      // this.dialogVisible4 = true;
      if (!this.checkAll) {
        this.tableclumn.sort(function (a, b) {
          return a.intOrderId - b.intOrderId;
        });
      }
      // console.log('this.tableclumn', this.tableclumn)
      const data = {
        custname: "全员导出",
        strworkstate: this.workState,
        outtype: "1",
        tableid: "XZ_emp_UserBase",
        roletype: localStorage.loginRoletype,
        tableclumn: this.tableclumn,
      };
      // console.log('导出', data)
      let Promise = xz.exportEmp(data);
      this.$router.push({
        path: "/operationRecord",
        query: {
          showPage: 1,
          isActive: 1,
          custname: "全员导出",
          //qStstus=1时查看最后一条导出记录
          qStstus: 1,
        },
      });
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    templateDownload() {
      xz.getImportMode().then((res) => {
        // console.log('a', res)
        if (res) {
          var d = res.msg.data.StrOutPath;
          d = d.replace('"', "").replace('"', "");
          var path = this.tablePath + d;
          this.modepath = path;
        }
      });
      this.dialogVisible3 = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-customer .el-button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.cus_down_form {
  margin-top: 8px;
}
.cus_down_form .el-form-item {
  margin-bottom: 3px;
}
.cus_down_form .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.cus_down_form .el-select,
.cus_down_form .el-form-item__content {
  width: 220px;
}
.p_roster_table.el-tabs--card {
  background-color: #fff;
}
.screenInputs .screenInput .el-input {
  width: 155px;
  margin-left: 5px;
}
.screenInput .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.screenInput .el-input__icon {
  line-height: 32px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.reimpArea .el-input__inner {
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
}
.reimpArea .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.employeeRosterTable .el-table th > .cell {
  padding: 0;
}
.employeeRosterTable .el-table .cell {
  padding: 0;
}
.employeeRosterTable .el-table td {
  padding: 6px 0;
}
.employeeRosterTable .el-table th {
  padding: 6px 0;
}

.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92 !important;
}
.el-popconfirm__action {
  margin-top: 15px;
}
</style>
